export const SIZES = 'sizes';
export const BRANDS = 'brands';
export const COLORS = 'colors';
export const PATTERNS = 'patterns';
export const MIN_PRICE = 'minPrice';
export const MAX_PRICE = 'maxPrice';
export const PRICE_TYPES = 'priceTypes';
export const STYLES = 'styles';
export const CONTEXTS = 'contexts';
export const OCCASIONS = 'occasion';
export const AVAILABILITY = 'availability';
export const DESIGNER = 'designer';
export const PRICE = 'price';
export const IN_STORE = 'inStore';
export const BACK_ORDER = 'BACK_ORDER';
export const PRE_ORDER = 'PRE_ORDER';
export const SIZE_LABELS = 'sizeLabels';
export const TYPES = 'types';
export const GROUPING = 'editsStatuses';
export const EDIT_FRAME = 'editsTypes';

export const INIT_FILTERS = {
  text: '',
  brands: '',
  sizes: '',
  colors: '',
  minPrice: '',
  maxPrice: '',
  priceTypes: '',
  patterns: '',
  styles: '',
  contexts: '',
  availability: '',
  inStore: '',
  sortBy: '',
  sortDirection: '',
  recommendedBrand: '',
  classId: '',
  divisionId: '',
  groupId: '',
  departmentId: '',
  sizeLabels: '',
};

export const INIT_EDIT_GALLERY_FILTERS = {
  brands: [],
  types: [],
  colors: [],
  styles: [],
  contexts: [],
};

export const HOLIDAY_FRAME_FILTERS = [
  { title: 'Holiday Product Spotlight', key: 'GIFT_1' },
  { title: 'Holiday Collection with 4 products', key: 'GIFT_4' },
  { title: 'Holiday Collection with 9 products', key: 'GIFT_9' },
];

export const priceTypesLabels = {
  REGULAR: 'Full price',
  ON_SALE: 'Sale',
  ON_PROMOTION: 'Promo',
};

export const MIN_PRODUCTS_FOR_LOOK_CREATION = 2;
export const MAX_PRODUCTS_FOR_LOOK_CREATION = 10;
